import { render, staticRenderFns } from "./MonitoringofSemenQualityUnderLongStorage.vue?vue&type=template&id=ce789a9e&scoped=true&"
import script from "./MonitoringofSemenQualityUnderLongStorage.vue?vue&type=script&lang=js&"
export * from "./MonitoringofSemenQualityUnderLongStorage.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringofSemenQualityUnderLongStorage.vue?vue&type=style&index=0&id=ce789a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce789a9e",
  null
  
)

export default component.exports